export default function EnergyBar({ state, compact = false }) {
  const { energy_pct = 0, level = 'low', label = 'Low Energy', energy = 0, energy_max = 1000 } = state || {};

  const colorMap = {
    low: { bar: 'bg-blue-500', glow: '', text: 'text-blue-400' },
    medium: { bar: 'bg-amber-500', glow: 'shadow-amber-500/30 shadow-lg', text: 'text-amber-400' },
    high: { bar: 'bg-orange-500', glow: 'shadow-orange-500/40 shadow-xl', text: 'text-orange-400' },
    max: { bar: 'bg-gradient-to-r from-red-500 via-pink-500 to-violet-500', glow: 'shadow-red-500/50 shadow-2xl', text: 'text-red-400' },
  };

  const colors = colorMap[level] || colorMap.low;

  if (compact) {
    return (
      <div className="flex items-center gap-2 px-3 py-1" data-testid="energy-bar-compact">
        <div className="flex-1 h-2 rounded-full bg-white/10 overflow-hidden">
          <div
            className={`h-full rounded-full transition-all duration-500 ease-out ${colors.bar}`}
            style={{ width: `${Math.min(100, energy_pct)}%` }}
          />
        </div>
        <span className={`text-[10px] font-bold ${colors.text} whitespace-nowrap`}>{label}</span>
      </div>
    );
  }

  return (
    <div className="fixed top-16 left-1/2 -translate-x-1/2 z-[85] w-[min(90vw,500px)]" data-testid="energy-bar">
      <div className={`relative rounded-full bg-black/60 backdrop-blur-md border border-white/10 p-1 ${colors.glow} transition-shadow duration-700`}>
        {/* Bar track */}
        <div className="h-4 rounded-full bg-white/5 overflow-hidden relative">
          {/* Fill */}
          <div
            className={`absolute inset-y-0 left-0 rounded-full transition-all duration-500 ease-out ${colors.bar} ${
              level === 'max' ? 'animate-energy-pulse' : ''
            }`}
            style={{ width: `${Math.min(100, energy_pct)}%` }}
          />
          {/* Shimmer overlay on high/max */}
          {(level === 'high' || level === 'max') && (
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent animate-shimmer" />
          )}
        </div>

        {/* Label */}
        <div className="absolute inset-0 flex items-center justify-between px-3 pointer-events-none">
          <span className="text-[10px] font-bold text-white/90 drop-shadow-sm">{label}</span>
          <span className="text-[10px] font-mono text-white/60">{energy}/{energy_max}</span>
        </div>
      </div>
    </div>
  );
}
